import {
  put,
  call,
  fork,
  all,
  take,
  takeLatest,
  select
} from "redux-saga/effects";
import * as types from "~/store/resource/resourceType";
import * as action from "~/store/resource/resourceAction";
import * as api from "~/store/resource/resourceApi";
import { getBaseUrl } from "~/utils/getBaseUrl";
import { client } from "~/utils/medproSDK";
import { get } from "lodash";

// term of service
function* requestGetTermOfService() {
  // const { data } = yield call(api.getTermOfService)
  // if (!data.error_code) {
  //   yield put({
  //     type: types.GET_TERM_OF_SERVICE_SUCCESS,
  //     payload: data.content,
  //   })
  // } else {
  //   yield put({
  //     type: types.GET_TERM_OF_SERVICE_FAIL,
  //     error: data.error_code,
  //   })
  // }

  try {
    const response = yield call(api.getTermOfService);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({
      type: types.GET_TERM_OF_SERVICE_SUCCESS,
      payload: data.content
    });
  } catch (error) {
    yield put({
      type: types.GET_TERM_OF_SERVICE_FAIL,
      error
    });
  }
}

function* watchRequestGetTermOfService() {
  yield takeLatest(types.GET_TERM_OF_SERVICE_REQUEST, requestGetTermOfService);
}

// Introduction
function* requestGetIntroduction() {
  // const response = yield call(api.getIntroduction)
  // const { data } = response
  // if (data && !data.error_code) {
  //   yield put(action.getIntroductionSuccess(data.content))
  // } else {
  //   yield put(action.getIntroductionFail(data ? data.error_code : 404))
  // }
  try {
    const response = yield call(api.getIntroduction);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put(action.getIntroductionSuccess(data.content));
  } catch (error) {
    yield put(action.getIntroductionFail(error));
  }
}

function* watchRequestGetIntroduction() {
  yield takeLatest(types.GET_INTRODUCTION_REQUEST, requestGetIntroduction);
}

// Private Policy
function* requestGetPrivatePolicy() {
  try {
    const response = yield call(api.getPrivatePolicy);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({ type: types.GET_PRIVATE_POLICY_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_PRIVATE_POLICY_FAIL, error });
  }
}
function* watchRequestGetPrivatePolicy() {
  yield takeLatest(types.GET_PRIVATE_POLICY_REQUEST, requestGetPrivatePolicy);
}

// usageRules
function* requestGetUsageRules() {
  // const { data } = yield call(api.getUsageRules)
  // if (!data.error_code) {
  //   yield put({
  //     type: types.GET_USAGE_RULES_SUCCESS,
  //     payload: data.content,
  //   })
  // } else {
  //   yield put({
  //     type: types.GET_USAGE_RULES_FAIL,
  //     error: data.error_code,
  //   })
  // }
  try {
    const response = yield call(api.getUsageRules);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({
      type: types.GET_USAGE_RULES_SUCCESS,
      payload: data.content
    });
  } catch (error) {
    yield put({
      type: types.GET_USAGE_RULES_FAIL,
      error
    });
  }
}
function* watchRequestGetUsageRules() {
  yield takeLatest(types.GET_USAGE_RULES_REQUEST, requestGetUsageRules);
}

/* holiday */
function* requestHoliday() {
  try {
    // const baseUrl = yield select(state => getBaseUrl());
    // const response = yield call(api.apiRequestHoliday, baseUrl);

    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const partnerid = yield select(state => state.totalData.partnerId);
    const cskhtoken = yield select(
      state => state.customerService.selectedPatient.secretKey
    );

    const response = yield client.getHolidays({
      partnerid,
      platform,
      cskhtoken
    });
    const { data } = response;

    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({ type: types.GET_HOLIDAY_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_HOLIDAY_FAIL, error });
  }
}

function* watchRequestHoliday() {
  yield takeLatest(types.GET_HOLIDAY_REQUEST, requestHoliday);
}

/* banner list */
function* requestBannerList() {
  try {
    const response = yield call(api.apiRequestBannerList);
    const { data = [] } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    if (typeof data.error_code === typeof undefined)
      yield put({ type: types.GET_BANNER_LIST_SUCCESS, data });
    else
      yield put({
        type: types.GET_BANNER_LIST_SUCCESS,
        data: []
      });
  } catch (error) {
    yield put({ type: types.GET_BANNER_LIST_FAIL, error });
  }
}

function* watchRequestBannerList() {
  yield takeLatest(types.GET_BANNER_LIST_REQUEST, requestBannerList);
}

// career
function* requestAllCareers() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const response = yield call(api.apiRequestAllCareers, baseUrl);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({ type: types.GET_ALL_CAREERS_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_ALL_CAREERS_FAIL, error });
  }
}

function* watchRequestAllCareers() {
  yield takeLatest(types.GET_ALL_CAREERS_REQUEST, requestAllCareers);
}

// nation
function* requestAllNation() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const response = yield call(api.apiRequestAllNation, baseUrl);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({ type: types.GET_ALL_NATION_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_ALL_NATION_FAIL, error });
  }
}
function* watchRequestAllNation() {
  yield takeLatest(types.GET_ALL_NATION_REQUEST, requestAllNation);
}

// country
function* requestAllCountries() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const response = yield call(api.apiRequestallCountries, baseUrl);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({ type: types.GET_ALL_COUNTRIES_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_ALL_COUNTRIES_FAIL, error });
  }
}
function* requestOnChangeCountry() {
  yield put({ type: types.RESET_WARD });
  yield put({ type: types.RESET_DISTRICT });
  yield put({ type: types.RESET_CITY });
  yield put({ type: types.GET_ALL_CITIES_BY_COUNTRY_REQUEST });
}
function* watchRequestAllCountries() {
  yield takeLatest(types.GET_ALL_COUNTRIES_REQUEST, requestAllCountries);
}
function* watchRequestAllCountriesSuccess() {
  while (yield take(types.GET_ALL_COUNTRIES_SUCCESS)) {
    yield put({ type: types.GET_ALL_CITIES_BY_COUNTRY_REQUEST });
    yield put({ type: types.GET_ALL_CITIES_V2_BY_COUNTRY_REQUEST });
  }
}
function* watchChangeCountry() {
  yield takeLatest(types.CHANGE_COUNTRY, requestOnChangeCountry);
}

// cities
function* requestAllCitiesByCountry() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    // const { selectedCountry } = yield select(state => state.allCountries);
    const { selectedCountry } = yield select(state => state.resource);
    const postData = {
      country_code: selectedCountry.id
    };
    const response = yield call(
      api.apiRequestAllCitiesByCountry,
      baseUrl,
      postData
    );
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({
      type: types.GET_ALL_CITIES_BY_COUNTRY_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: types.GET_ALL_CITIES_BY_COUNTRY_FAIL,
      error
    });
  }
}

function* requestOnChangeCity() {
  yield put({ type: types.RESET_WARD });
  yield put({ type: types.RESET_DISTRICT });
  yield put({ type: types.GET_ALL_DISTRICTS_BY_CITY_REQUEST });
}

function* watchRequestAllCitiesByCountry() {
  yield takeLatest(
    types.GET_ALL_CITIES_BY_COUNTRY_REQUEST,
    requestAllCitiesByCountry
  );
}
function* watchChangeCity() {
  yield takeLatest(types.CHANGE_CITY, requestOnChangeCity);
}

// cities V2
function* requestAllCitiesV2ByCountry() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const { selectedCountry } = yield select(state => state.resource);
    const postData = {
      country_code: selectedCountry.id
    };
    const response = yield call(
      api.apiRequestAllCitiesV2ByCountry,
      baseUrl,
      postData
    );
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({
      type: types.GET_ALL_CITIES_V2_BY_COUNTRY_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: types.GET_ALL_CITIES_V2_BY_COUNTRY_FAIL,
      error
    });
  }
}

function* requestOnChangeCityV2() {
  yield put({ type: types.RESET_WARD_V2 });
  yield put({ type: types.GET_ALL_WARDS_V2_BY_CITY_REQUEST });
}

function* watchRequestAllCitiesV2ByCountry() {
  yield takeLatest(
    types.GET_ALL_CITIES_V2_BY_COUNTRY_REQUEST,
    requestAllCitiesV2ByCountry
  );
}
function* watchChangeCityV2() {
  yield takeLatest(types.CHANGE_CITY_V2, requestOnChangeCityV2);
}

// district
function* requestAllDistrictsByCity() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const { selectedCity } = yield select(state => state.resource);
    const postData = {
      city_id: selectedCity.id
    };
    const response = yield call(
      api.requestAllDistrictsByCity,
      baseUrl,
      postData
    );
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({
      type: types.GET_ALL_DISTRICTS_BY_CITY_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: types.GET_ALL_DISTRICTS_BY_CITY_FAIL,
      error
    });
  }
}

function* requestOnChangeDistrict() {
  yield put({ type: types.RESET_WARD });
  yield put({ type: types.GET_ALL_WARDS_BY_DISTRICT_REQUEST });
}

function* watchRequestAllDistrictsByCity() {
  yield takeLatest(
    types.GET_ALL_DISTRICTS_BY_CITY_REQUEST,
    requestAllDistrictsByCity
  );
}

function* watchChangeDistrict() {
  yield takeLatest(types.CHANGE_DISTRICT, requestOnChangeDistrict);
}

// ward
function* requestAllWardsByDistrict() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    // const { selectedDistrict } = yield select(state => state.allDistricts);
    const { selectedDistrict } = yield select(state => state.resource);
    const postData = {
      district_id: selectedDistrict.id
    };
    const response = yield call(
      api.requestAllWardsByDistrict,
      baseUrl,
      postData
    );
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({
      type: types.GET_ALL_WARDS_BY_DISTRICT_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: types.GET_ALL_WARDS_BY_DISTRICT_FAIL,
      error
    });
  }
}

function* watchRequestAllWardsByDistrict() {
  yield takeLatest(
    types.GET_ALL_WARDS_BY_DISTRICT_REQUEST,
    requestAllWardsByDistrict
  );
}

// ward V2
function* requestAllWardsV2ByCity() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const { selectedCityV2 } = yield select(state => state.resource);

    const postData = {
      city_id: selectedCityV2.id
    };
    const response = yield call(api.requestAllWardsByCity, baseUrl, postData);
    const { data } = response;
    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({
      type: types.GET_ALL_WARDS_V2_BY_CITY_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: types.GET_ALL_WARDS_V2_BY_CITY_FAIL,
      error
    });
  }
}

function* watchRequestAllWardsByCity() {
  yield takeLatest(
    types.GET_ALL_WARDS_V2_BY_CITY_REQUEST,
    requestAllWardsV2ByCity
  );
}

// relationship
function* requestAllRelationShip() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const response = yield client.getRelationType({
      partnerid: "medpro",
      platform
    });
    const { data } = response;

    if (response.status !== 200 || response.data.error_code) {
      throw new Error("Lỗi server!");
    }
    yield put({
      type: types.GET_ALL_RELATIONSHIP_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: types.GET_ALL_RELATIONSHIP_FAIL,
      error
    });
  }
}
function* watchRequestAllRelationShip() {
  yield takeLatest(types.GET_ALL_RELATIONSHIP_REQUEST, requestAllRelationShip);
}

function* requestTermBeforeLogin() {
  const { data } = yield call(api.getTermBeforeLogin);
  if (!data.error_code) {
    yield put(action.getTermBeforeLoginSuccess(data));
  } else {
    yield put(action.getTermBeforeLoginFail(data.error_code));
  }
}

function* watchRequestTermBeforeLogin() {
  yield takeLatest(types.GET_TERM_BEFORE_LOGIN, requestTermBeforeLogin);
}

export default function* root() {
  yield all([
    fork(watchRequestGetTermOfService),
    fork(watchRequestGetIntroduction),
    fork(watchRequestGetPrivatePolicy),
    fork(watchRequestGetUsageRules),
    fork(watchRequestHoliday),
    fork(watchRequestBannerList),
    fork(watchRequestAllCareers),
    fork(watchRequestAllCitiesByCountry),
    fork(watchRequestAllCitiesV2ByCountry),
    fork(watchChangeCity),
    fork(watchChangeCityV2),
    fork(watchRequestAllCountries),
    fork(watchRequestAllCountriesSuccess),
    fork(watchChangeCountry),
    fork(watchRequestAllDistrictsByCity),
    fork(watchChangeDistrict),
    fork(watchRequestAllNation),
    fork(watchRequestAllWardsByDistrict),
    fork(watchRequestAllWardsByCity),
    fork(watchRequestAllRelationShip),
    fork(watchRequestTermBeforeLogin)
  ]);
}
